export const artikel5 = `
<strong>Larangan larangan umroh</strong> ini adalah hal yang sering banget luput dari perhatian para jamaah umroh ketika melaksanakan umroh atau ketika berihrom yaitu menghindari larangan atau sesuatu yang membatalkan ihrom atau umroh tersebut,

Larangan larangan ini terbagi menjadi 3,

<strong>Pertama,</strong> dilarang melakukan maksiat ataupun sesuatu yang kotor

Dalam surah Al Baqarah ayat 197 Allah berfirman,

فَمَن فَرَضَ فِيهِنَّ الْحَجَّ فَلَا رَفَثَ وَلَا فُسُوقَ وَلَا جِدَالَ فِي الْحَ

“Janganlah berbuat rafaṡ, berbuat maksiat, dan bertengkar dalam (melakukan ibadah) haji. Segala kebaikan yang kamu kerjakan (pasti) Allah mengetahuinya. Berbekallah karena sesungguhnya sebaik-baik bekal adalah takwa. Bertakwalah kepada-Ku wahai orang-orang yang mempunyai akal sehat”

<strong>Kedua,</strong> memotong kuku atau rambut

Ini yang sering sekali diremehkan karenanya sebisa mungkin kita menghindari dulu bersisir dan juga keramas.

<strong>Ketiga,</strong> bersenggama antara suami istri

<strong>Keempat,</strong> berburu binatang dan memakannya

    وَحُرِّمَ عَلَيْكُمْ صَيْدُ الْبَرِّ مَا دُمْتُمْ حُرُمًا

“Diharamkan bagimu (menangkap) binatang buruan darat selama kamu dalam ihram.” (QS Al-Maidah: 96)

Yang termasuk kedalamnya adalah unta sapi domba burung dan Binatang apapun yang sekiran nya di manfaat kan daging nya

<strong>Kelima,</strong> menggunakan wewangian

Termasuk juga kedalamnya handbody, sunscream dan apapun yang memiliki wewangian dan aroma.

<strong>Keenam,</strong> menikah atau menikahkan

<strong>Larangan Khusus Laki-laki </strong>

- Dilarang menggunakan sesuatu yang berjahit apapun itu baik pakaian dalam ataupun sandal yang menggunakan jahitan.
- Dilarang menggunakan penutup kepala seperti peci atau pun qimamah seperti sorban
 
<strong>Larangan Khusus Perempuan</strong>

- Harus menutup aurat
- Harus membuka area wajah dan juga telapak tangan jangan sampai tertutup oleh kain

Jadi jangan sampai kita melanggar larangan-larangan di atas, karena bisa membatalkan ibadah umroh dan juga bisa mengakibatkan terkenanya dam ataupun denda yang telah di tentukan.

Tapi jangan khawatir, bagi para jamaah yang umroh bersama Sanematour, Kami selalu mengadakan Manasik di hotel sebelum keberangkatan. Insyaa Allah terkait fiqh umroh akan dijelaskan dan pastinya mudah dipahami agar jamaah sekalian dapat beribadah umroh khusu, semoga mabrur dan mabruroh.

`;
